import React from 'react';
import PropTypes from 'prop-types';
import AdminNavigationItem from './navigation-item';

const AdminNavigation = ({items, history, privileged}) => (
	<div>
		{items.filter(item => privileged || !item.privileged)
			.map((item, key) => (
				<AdminNavigationItem key={key} history={history} {...item}/>
			))}
	</div>
);

AdminNavigation.propTypes = {
	items: PropTypes.array.isRequired,
	history: PropTypes.object.isRequired,
	privileged: PropTypes.bool.isRequired
};

export default AdminNavigation;



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/navigation/navigation.jsx